$('.benefit-content-header').on('click', function () {
  $(this).next('.benefit-content-text').toggleClass('open')
})
